import React from 'react'

import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    clipRule="evenodd"
    d="M5 6H19C19.5523 6 20 6.44771 20 7V9H4V7C4 6.44772 4.44772 6 5 6ZM4 12V17C4 17.5523 4.44772 18 5 18H19C19.5523 18 20 17.5523 20 17V12H4ZM2 7C2 5.34315 3.34315 4 5 4H19C20.6569 4 22 5.34315 22 7V17C22 18.6569 20.6569 20 19 20H5C3.34315 20 2 18.6569 2 17V7Z"
    fillRule="evenodd"
  />,
  'CreditCardIcon',
)
